<template>
    <span>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            :width="`${width}px`"
            :height="`${height}px`"
        >
            <path opacity=".8" d="M0 0h24v24H0z" />
            <path class="st1" d="M13.3 4.5h6.6V11M14.3 10.1l5.6-5.6" />
            <g>
                <path class="st1" d="M11.4 19.5H4.9V13M10.7 13.7l-5.8 5.8" />
            </g>
        </svg>
    </span>
</template>
<script>
export default {
	name: 'IconExpand',
	props: {
		height: {
			type: Number,
			default: 24,
		},
		width: {
			type: Number,
			default: 24,
		},
	},
};
</script>
<style>
.st1 {
	fill: none;
	stroke: #fff;
	stroke-miterlimit: 10;
}
</style>
